'use strict';
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');
var { objectHelper } = require('amb/helpers/object.helper');

/**
 * Updates location details in cookies
 *
 * @param {Object} address - Location details object
 */
function updateLocationCookies(locationDetails, autoUpdateUserLocation) {
    if (!locationDetails || !locationDetails.state || !locationDetails.postalCode || !locationDetails.country) {
        console.warn('Incomplete location details. Unable to update cookies.');
        return;
    }

    var isAustralia = locationDetails.country.code === 'AU';
    var isAuPostcode = /^\d{4}$/.test(String(locationDetails.postalCode));
    if (!isAustralia || !isAuPostcode) {
        console.warn('Non-Australian location detected. Cookie not stored.');
        if (window.ecux && typeof window.ecux.notify === 'function') {
            window.ecux.notify('We couldn’t detect an Australian location. Please enter a valid Australian postcode to see accurate drive away pricing.', '', 'warning');
        }
        return;
    }

    // generates additional summary attribute to be used with components
    locationDetails.summary = `${locationDetails.city ? locationDetails.city : ''} ${locationDetails.state.code} ${locationDetails.postalCode}`;

    // Update cookies with location details. Cookie expires in 15 days (setCookie days arg)
    var objString = JSON.stringify(locationDetails);

    // Set the cookie (userloc goes through locationStorage under tab isolation)
    var cookieID = 'userloc';
    if (!autoUpdateUserLocation) {
        cookieID = 'tempuserloc';
    }

    frontendUtils.setCookie(cookieID, objString, 15);

    $('body').trigger('location:afterUpdate', { cookieID: cookieID });
    $('body').trigger('stores:getDealers', { cookieID: cookieID });
}


function initConfirmLocationEvent() {
    var params = new URLSearchParams(window.location.search);
    var userId = params.get('userId') || '';
    var sessionId = params.get('sessionId') || '';
    if (!frontendUtils.getCookie('userloc') && (!userId || !sessionId)) {
        detectLocation();
    }
    $('body').on('location:confirmLocation', function () {
        $('body').trigger('location:beforeConfirmLocation');
        var previous = objectHelper.parse(frontendUtils.getCookie('userloc'), {});
        var nextPlace = objectHelper.parse(frontendUtils.getCookie('tempuserloc'), {});
        var merged = {
            ...previous,
            ...nextPlace
        };

        // Autocomplete selection writes tempuserloc. Without it (typed-only input),
        // do not promote an empty/incomplete object to userloc — that would skip the
        // location modal on reload while leaving footer summary blank.
        if (!merged.postalCode || !merged.state || !merged.country) {
            return;
        }

        frontendUtils.setCookie('userloc', JSON.stringify(merged));
        $('body').trigger('location:afterConfirmLocation');
    });
}

/**
 * Extracts address details from the place or geometry object
 *
 * @param {Object} place - The place object from the Autocomplete API
 * @returns {Object} - Address details
 */
function extractLocationDetails(place) {
    var locationDetails = {};

    place.address_components.forEach(function (component) {
        var componentTypes = component.types;

        if (componentTypes.includes('locality')) {
            locationDetails.city = component.long_name;
        } else if (componentTypes.includes('postal_code')) {
            locationDetails.postalCode = component.long_name;
        } else if (componentTypes.includes('administrative_area_level_1')) {
            locationDetails.state = {
                code: component.short_name,
                name: component.long_name
            };
        } else if (componentTypes.includes('country')) {
            locationDetails.country = {
                code: component.short_name,
                name: component.long_name
            };
        }
    });

    return locationDetails;
}

/**
 * Finds the first complete address from the results array
 *
 * @param {Array} results - Array of address results
 * @returns {Object|null} - Address details or null
 */
function findCompleteLocation(results) {
    for (var i = 0; i < results.length; i++) {
        var locationDetails = extractLocationDetails(results[i]);
        if (locationDetails.city && locationDetails.postalCode && locationDetails.state && locationDetails.country) {
            // Return the first match with all required fields
            return locationDetails;
        }
    }

    return null;
}

/**
 * Detects the user's current location using the Geolocation API and retrieves the address details.
 * If successful, it updates location cookies with the retrieved address.
 *
 * @param {HTMLElement} [triggerEl] The clicked `.user-current-location` control, used to find the
 *   nearby autocomplete input and honour its `data-autoupdateuserlocation`. Page-load autodetection
 *   omits this and falls back to the first matching input.
 */
function detectLocation(triggerEl) {
    var fieldName = window.googleAddressAutoComplete.AUTOCOMPLETE_TRIGGER_FIELD_NAME;
    var el = null;
    var autoUpdateUserLocation = true;
    var scope;

    if (triggerEl && triggerEl.closest) {
        scope = triggerEl.closest('.configurator-location') || triggerEl.parentElement;
        el = scope ? scope.querySelector('input[name$=' + fieldName + ']') : null;
    }

    if (!el) {
        el = document.querySelector('input[name$=' + fieldName + ']');
    }

    if (el && el.dataset && el.dataset.autoupdateuserlocation === 'false') {
        autoUpdateUserLocation = false;
    }

    if (!navigator.geolocation) {
        alert("Sorry your browser doesn't support geolocation.");
        return;
    }

    navigator.geolocation.getCurrentPosition(function (position) {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;

        if (lat && lng) {
            var LatLng = new google.maps.LatLng(lat, lng);

            initGeocoder(LatLng).then(function (locationDetails) {
                if (locationDetails) {
                    // add lat & long
                    Object.assign(locationDetails, {
                        lat: lat,
                        lng: lng
                    });
                    updateLocationCookies(locationDetails, autoUpdateUserLocation);
                }
            }).catch(function (error) {
                console.warn(error);
            });
        } else {
            console.warn('Unable to detect current location.');
        }
    });
}

/**
 * Retrieves address using geocoder and returns a promise
 *
 * @param {Object} location - The location object
 * @returns {Promise} - Resolves to the address details
 */
function initGeocoder(location) {
    var geocoder = new google.maps.Geocoder();

    return new Promise(function (resolve, reject) {
        geocoder.geocode({
            location: location
        }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK && results) {
                var locationDetails = findCompleteLocation(results);
                if (locationDetails) {
                    resolve(locationDetails);
                } else {
                    reject('No complete location details found.');
                }
            } else {
                reject('Error retrieving location details: ' + status);
            }
        });
    });
}

/**
 * Initializes the Google Places Autocomplete for a single input field
 *
 * @param {HTMLElement} inputField - The input field for location
 */
function initAutocomplete(inputField) {
    var autoComplete = new google.maps.places.Autocomplete(inputField);
    var autoUpdateUserLocation = (inputField && inputField.dataset && inputField.dataset.autoupdateuserlocation === 'false') ? false : true;

    autoComplete.setFields(['address_components', 'geometry']);
    autoComplete.setTypes(['postal_code', 'locality', 'administrative_area_level_1', 'administrative_area_level_2', 'country']);
    autoComplete.setComponentRestrictions({
        country: ['au']
    });

    autoComplete.addListener('place_changed', function () {
        var place = autoComplete.getPlace();

        if (place && place.address_components && place.geometry && place.geometry.location) {
            var locationDetails = extractLocationDetails(place);

            // add lat & long
            Object.assign(locationDetails, {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            });

            // If postal code is missing, fetch it using geocoder
            if (!locationDetails.postalCode) {
                initGeocoder(place.geometry.location).then(function (geoCodeLocationDetails) {
                    if (geoCodeLocationDetails) {
                        locationDetails.postalCode = geoCodeLocationDetails.postalCode;
                        updateLocationCookies(locationDetails, autoUpdateUserLocation);
                    }
                }).catch(function (error) {
                    console.warn(error);
                });
            } else {
                updateLocationCookies(locationDetails, autoUpdateUserLocation);
            }
        } else {
            console.warn('No location details found.');
        }
    });
}

/**
 * Initializes the autocomplete functionality for a given input field
 *
 * @param {string} inputSelector - The selector for the input field
 */
function init(inputSelector) {
    var locationInputFields = document.querySelectorAll(inputSelector);
    if (locationInputFields.length) {
        locationInputFields.forEach(function (locationInputField) {
            initAutocomplete(locationInputField);
        });
    };

    initConfirmLocationEvent();
}

window.addEventListener('load', function () {
    setTimeout(() => {
        if (window.googleAddressAutoComplete && window.googleAddressAutoComplete.ENABLED) {
            init('input[name$=' + window.googleAddressAutoComplete.AUTOCOMPLETE_TRIGGER_FIELD_NAME + ']');

            // detect current location
            let allUserCurrentLocation = document.querySelectorAll('.user-current-location');
            allUserCurrentLocation.forEach(function (userCurrentLocationBtn) {
                userCurrentLocationBtn.addEventListener('click', function () {
                    detectLocation(userCurrentLocationBtn);
                });
            });
        }
    }, 1000);
});
